import React from "react";
import { Box, Text, Button, Tooltip } from "@showitinc/showit-wc";
import { toUnicode } from "../utils/DomainUtils";
import Glyphicon from "./base/Glyphicon";

function DomainSelectorHeader({ domain, onConfigureClick }) {
  return (
    <Box d="flex" justify="start" gp="2" align="center">
      <Text>DOMAIN:</Text>
      <span data-testid="selected-domain-name">{toUnicode(domain.domain_name || "")}</span>
      <Tooltip>
        <span slot="content">
          <Text>Configure Domain</Text>
        </span>
        <Button
          variant="icon"
          size="sm"
          onSIClick={onConfigureClick}
          title="Configure Domain"
          iconPrefix="settings"
        />
      </Tooltip>
    </Box>
  );
}

export default DomainSelectorHeader;
